/** Shared inline exception/rule banner - renders the list of triggered demo rules-engine
 * exceptions (see `src/utils/rulesEngine.ts`) as stacked MUI Alerts. Reused across Orders,
 * PurchaseOrders, WasteChecksheet, Suppliers and RecipeV2 wherever a rules-engine scenario
 * needs to surface inline. Purely presentational - no data fetching. */

import { Alert, AlertTitle, Stack } from '@mui/material';
import { TriggeredException } from '../../utils/rulesEngine';

const SEVERITY_TO_ALERT: Record<TriggeredException['severity'], 'info' | 'warning' | 'error'> = {
  Info: 'info',
  Warning: 'warning',
  Blocking: 'error',
};

export interface ExceptionBannerProps {
  exceptions: TriggeredException[];
}

const ExceptionBanner: React.FC<ExceptionBannerProps> = ({ exceptions }) => {
  if (exceptions.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1}
      sx={{ mb: 2 }}>
      {exceptions.map((exception) => (
        <Alert key={exception.ruleCode}
          severity={SEVERITY_TO_ALERT[exception.severity]}
          variant="outlined">
          <AlertTitle>{exception.title}</AlertTitle>
          {exception.message}
        </Alert>
      ))}
    </Stack>
  );
};

export default ExceptionBanner;
